/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { Button } from 'edrolo-style-guide';
import { useRef, useState } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import Arrow from './Arrow';
import CorrectnessLegendSVG from './CorrectnessLegendSVG';

import style from './LayerFilter.scss';

const Header = () => {
  return (
    <div>
      <h4 className={style.filterHeader}>Multiple choice questions</h4>
    </div>
  );
};

const Checkbox = ({
  className = '',
  id,
  name,
  value,
  checked,
  indeterminate,
  onChange,
  children,
}) => {
  return (
    <div className={style.checkboxWrapper}>
      <input
        className={className}
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        ref={(el) => el && (el.indeterminate = indeterminate)}
      />
      {children}
    </div>
  );
};

const LayerFilter = ({
  showCorrectLayer,
  setShowCorrectLayer,
  showIncorrectLayer,
  setShowIncorrectLayer,
  correctMCQresponseCount,
  incorrectMCQresponseCount,
  analyticsPayload,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const indeterminate =
    (showCorrectLayer && !showIncorrectLayer) ||
    (!showCorrectLayer && showIncorrectLayer);
  const onClear = () => {
    setShowCorrectLayer(false);
    setShowIncorrectLayer(false);
  };

  return (
    <div className={style.container}>
      <Overlay
        show={open}
        target={ref.current}
        rootClose
        onHide={() => {
          setOpen(false);

          global.analytics.track(
            'closed question set results grid filters overlay',
            { ...analyticsPayload, method: 'clicked outside overlay' }
          );
        }}
        placement="bottom"
        animation={false}
      >
        <Popover
          id="layer-filter-popover"
          title=""
          className={style.layerFilterPopover}
        >
          <Header />
          <Checkbox
            className={style.allCheckbox}
            id="id-all-checkbox"
            name="all"
            value="all"
            checked={showCorrectLayer && showIncorrectLayer}
            indeterminate={indeterminate}
            onChange={(checked) => {
              if (indeterminate) {
                onClear();

                global.analytics.track(
                  'modified question set results grid filters',
                  // TBC: action: 'indeterminate'?
                  { ...analyticsPayload, content: 'all', action: 'off' }
                );
              } else {
                checked
                  ? global.analytics.track(
                      'modified question set results grid filters',
                      { ...analyticsPayload, content: 'all', action: 'on' }
                    )
                  : global.analytics.track(
                      'modified question set results grid filters',
                      { ...analyticsPayload, content: 'all', action: 'off' }
                    );
                setShowCorrectLayer(checked);
                setShowIncorrectLayer(checked);
              }
            }}
          >
            <label htmlFor="id-all-checkbox" className={style.checkboxLabel}>
              <span className={style.labelText}>All</span>
            </label>
          </Checkbox>

          <Checkbox
            className={style.checkbox}
            id="id-correct-checkbox"
            name="correct"
            value="correct"
            checked={showCorrectLayer}
            onChange={(checked) => {
              setShowCorrectLayer(checked);

              checked
                ? global.analytics.track(
                    'modified question set results grid filters',
                    { ...analyticsPayload, content: 'correct', action: 'on' }
                  )
                : global.analytics.track(
                    'modified question set results grid filters',
                    { ...analyticsPayload, content: 'correct', action: 'off' }
                  );
            }}
          >
            <label
              htmlFor="id-correct-checkbox"
              className={style.checkboxLabel}
            >
              <CorrectnessLegendSVG correct />
              <span className={style.labelText}>Correct</span>
              <span className={style.correctnessCount}>
                ({correctMCQresponseCount})
              </span>
            </label>
          </Checkbox>

          <Checkbox
            className={style.checkbox}
            id="id-incorrect-checkbox"
            name="incorrect"
            value="incorrect"
            checked={showIncorrectLayer}
            onChange={(checked) => {
              setShowIncorrectLayer(checked);

              checked
                ? global.analytics.track(
                    'modified question set results grid filters',
                    { ...analyticsPayload, content: 'incorrect', action: 'on' }
                  )
                : global.analytics.track(
                    'modified question set results grid filters',
                    { ...analyticsPayload, content: 'incorrect', action: 'off' }
                  );
            }}
          >
            <label
              htmlFor="id-incorrect-checkbox"
              className={style.checkboxLabel}
            >
              <CorrectnessLegendSVG incorrect />
              <span className={style.labelText}>Incorrect</span>
              <span className={style.correctnessCount}>
                ({incorrectMCQresponseCount})
              </span>
            </label>
          </Checkbox>

          <div className={style.filterMenuButtons}>
            <Button
              small
              clear
              className={style.clearButton}
              onClick={() => {
                onClear();

                global.analytics.track(
                  'clicked question set results grid clear filters button',
                  analyticsPayload
                );
              }}
              disabled={!(showCorrectLayer || showIncorrectLayer)}
            >
              Clear
            </Button>
            <Button
              className={style.doneButton}
              onClick={() => {
                setOpen(false);
                global.analytics.track(
                  'closed question set results grid filters overlay',
                  {
                    ...analyticsPayload,
                    method: 'done button',
                  }
                );
              }}
              small
            >
              Done
            </Button>
          </div>
        </Popover>
      </Overlay>
      <Button
        outline
        ref={ref}
        aria-controls="layer-filter-button"
        aria-expanded={open}
        className={cx(style.filterButton, { [style.buttonOpen]: open })}
        onClick={() => {
          setOpen(!open);

          !open
            ? global.analytics.track(
                'opened question set results grid filters overlay',
                analyticsPayload
              )
            : global.analytics.track(
                'closed question set results grid filters overlay',
                {
                  ...analyticsPayload,
                  method: 'filters button',
                }
              );
        }}
      >
        Filters <Arrow isOpen={open} />
      </Button>
    </div>
  );
};

export default LayerFilter;
